import { TInfrastructureItem } from '../../../../../types/map';

export function getIconBackgroundColor(infrastructureItem: TInfrastructureItem) {
  return 'constructionYearFrom' in infrastructureItem ? 'green' : 'blue';
}
